import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { Link } from '@material-ui/core'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import GetAppIcon from '@material-ui/icons/GetApp'
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import IconButton from '@material-ui/core/IconButton'
// import { useSnackbar } from 'notistack'
import Button from '../Button'
import Dialog from '../Dialog'

const useStyles = createUseStyles(
  {
    'font-container': {
      display: 'flex',
      direction: (props) => (props.font.font_lang === 'en' ? 'ltr' : 'rtl'),
      // justifyContent: 'center',
      alignContent: 'center',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: '28px'
    },
    'font-table': {
      padding: '6px',
      margin: 0,
      border: '0.5px #ddd solid',
      width: '46px',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: (props) => props.font.font_name,
      fontSize: (props) =>
        props.font.font_type === 'header' ? '16px' : '14px',
      fontWeight: (props) =>
        props.font.font_type === 'header' ? 'bold' : 'normal'
    }
  },
  { name: 'bund-' }
)

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 46,

    '&$expanded': {
      minHeight: 46
    }
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&$expanded': {
      margin: '12px 0'
    }
  },

  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails)

export const Font = (props) => {
  const { client, className, font, letters, handleDeleteMsg, style, ...rest } =
    props
  const [expanded, setExpanded] = useState('')
  const [open, setOpen] = useState(false)
  const [fontUid, setFontUid] = useState('')
  const [state, setState] = useState('')
  // const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleFontDelete = async (e) => {
    e.preventDefault()
    const fontDeleteUrl =
      '/api/v1/bund-clients/delete/client/font/' +
      client.client_uid +
      '&' +
      localStorage['bund_uid'] +
      '&' +
      fontUid

    const token = localStorage['BUND-X-AUTH-TOKEN']
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Bearer ' + token
      },
      body: JSON.stringify({
        font_uid: fontUid
      })
    }
    setState({ loading: true })
    fetch(fontDeleteUrl, requestOptions).then((r) => {
      if (r.status === 403) {
        handleDeleteMsg
      } else {
        setTimeout(location.reload.bind(location), 1000) && handleDeleteMsg
      }
    })
  }

  const classes = useStyles(props)
  return (
    <div className={className} style={style} {...rest}>
      <Accordion
        style={{
          borderRadius: '6px'
        }}
        className="card-body-color card-border-color"
        square
        expanded={expanded === font.font_name}
        onChange={handleChange(font.font_name)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <div>
            <h6
              className="text-color"
              style={{
                margin: 0,
                textTransform: 'uppercase'
              }}>
              {font.font_name}
            </h6>
          </div>
          <div>
            <Link href={font.font_full_url} className="text-color">
              <IconButton
                color="inherit"
                aria-label="add-new-font"
                style={{
                  outline: 'none',
                  padding: '6px'
                }}>
                <GetAppIcon
                  style={{
                    fontSize: 'small'
                  }}
                />
              </IconButton>
            </Link>
            <IconButton
              color="inherit"
              aria-label="add-new-font"
              type="submit"
              onClick={() => handleClickOpen(setFontUid(font.font_uid))}
              style={{
                outline: 'none',
                padding: '6px'
              }}>
              <HighlightOffOutlinedIcon
                style={{
                  fontSize: 'small',
                  color: 'red'
                }}
              />
            </IconButton>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className={classes['font-container']}>
            {letters.map((l) => {
              return (
                <p
                  className={clsx(classes['font-table'], 'text-color')}
                  key={uuid()}>
                  {l}
                </p>
              )
            })}
          </div>
        </AccordionDetails>
      </Accordion>
      <Dialog
        style={{
          background: 'center'
        }}
        title={'Are you sure?'}
        open={open}
        onClose={handleClose}
        content={
          <span
            style={{
              display: 'flex'
            }}>
            <ReportProblemOutlinedIcon
              fontSize="small"
              style={{
                color: 'red'
              }}
            />{' '}
            <span>Are you sure you want to delete this font ?</span>
          </span>
        }
        cancel
        actions={
          <form
            style={{
              float: 'right'
            }}
            onSubmit={handleFontDelete}
            noValidate>
            <Button size="xs" variant="outline" color="danger" type="submit">
              Delete
            </Button>
          </form>
        }
      />
    </div>
  )
}

Font.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  font: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  letters: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

Font.displayName = 'f'

export default Font
